"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const login2FASelector_1 = require("../selectors/login2FASelector");
const types_1 = require("../types");
const login2FAAction_1 = require("../actions/login2FAAction");
const react_intl_1 = require("react-intl");
const constants_1 = require("../constants");
const Login2FAOTPStyle_1 = __importDefault(require("./styles/Login2FAOTPStyle"));
const material_1 = require("@mui/material");
const PopupTwoFASigning = ({ intl }) => {
    const classes2 = (0, Login2FAOTPStyle_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { layoutStatus, otpCode } = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    const [otpError, setOtpError] = (0, react_1.useState)({});
    const handleToggleSubmitOTP = () => {
        console.log('handleToggleSubmitOTP');
        if (otpCode && otpCode.length === 6) {
            setOtpError({});
            dispatch((0, login2FAAction_1.toggleSubmitHardWareToken)());
        }
        else {
            setOtpError(constants_1.SYSTEM_MESSAGES_LOGIN2FA.OTP_ERROR_EMPTY_OTP);
        }
    };
    const handleOtpInputChange = (event) => {
        const value = event.target.value;
        if (value && value.length > 6) {
            return;
        }
        dispatch((0, login2FAAction_1.setOtpCode)(value));
    };
    const handleToggleCloseOTP = () => {
        console.log('handleToggleCloseOTP');
        dispatch((0, login2FAAction_1.toggleCloseOtp)());
    };
    // OTP image to be rendered in the middle of formattedMessage
    const OTPimage = react_1.default.createElement("span", { className: classes2.OTPButtonImg });
    return (react_1.default.createElement(material_1.Dialog, { open: layoutStatus === types_1.LayoutStatus.HARD_WARE_TOKEN, classes: { paper: classes2.dialog }, TransitionComponent: material_1.Slide },
        react_1.default.createElement("div", { className: classes2.DialogContentOuter },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                } },
                react_1.default.createElement(material_1.Typography, { className: classes2.OTPTitle, variant: "h3" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "popup-twofa-signing-title" })),
                react_1.default.createElement(material_1.Link, { id: "iconClose", className: classes2.IconClose, onClick: handleToggleCloseOTP })),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.ListItem, { id: "lisItem", className: classes2.ListItem },
                    react_1.default.createElement(material_1.ListItemText, { id: "lisText", className: classes2.ListItemText },
                        react_1.default.createElement("div", { className: classes2.StepTips },
                            react_1.default.createElement("div", { className: classes2.FieldGroup },
                                react_1.default.createElement(material_1.Typography, { id: "stepTitle", className: classes2.StepTitle },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-1" })),
                                react_1.default.createElement("div", { className: classes2.StepOTP },
                                    react_1.default.createElement("div", { className: classes2.StepContent },
                                        react_1.default.createElement("div", { className: classes2.StepTxt },
                                            react_1.default.createElement(material_1.Typography, { id: "stepContent", className: classes2.typography },
                                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-hard-token-step-1-content", values: { OTPimage: OTPimage } })))),
                                    react_1.default.createElement("span", { className: classes2.OTPButtonImg })))),
                        react_1.default.createElement("div", { className: classes2.StepTips },
                            react_1.default.createElement("div", { className: classes2.FieldGroup },
                                react_1.default.createElement(material_1.Typography, { className: classes2.StepTitle },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-2" })),
                                react_1.default.createElement("div", { className: classes2.StepOTP },
                                    react_1.default.createElement("div", { className: classes2.StepContent },
                                        react_1.default.createElement("div", { className: classes2.StepTxt },
                                            react_1.default.createElement(material_1.Typography, { id: "stepText", className: classes2.typography }, "Enter the 6-digit One-Time Password"),
                                            react_1.default.createElement("div", { className: classes2.InputOTP },
                                                react_1.default.createElement(material_1.Input, { className: classes2.OTP, classes: { input: classes2.InputHeight, focused: classes2.InputFocus }, name: "OTP", type: "password", value: otpCode, onChange: handleOtpInputChange, fullWidth: true, disableUnderline: true }),
                                                otpError && Object.keys(otpError).length > 0 ? (react_1.default.createElement("div", { id: "errorOTP", className: classes2.OtpError },
                                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: otpError.msgId, defaultMessage: otpError.defaultMsg }))) : null))),
                                    react_1.default.createElement("span", { className: classes2.OTPButtonImg })))))),
                react_1.default.createElement("div", { className: "SubmitOutline" },
                    react_1.default.createElement(material_1.Button, { className: classes2.Submit, onClick: handleToggleSubmitOTP, disableTouchRipple: true, disableFocusRipple: true },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-otp-step-submit" })))))));
};
exports.default = (0, react_intl_1.injectIntl)(PopupTwoFASigning);
